import { get } from "lodash";
import { Features } from "@linkfluence/models/feature";
import { useFeatures } from "./useFeatures";

export function useFeature(feature: keyof Features) {
  return !!get(useFeatures(), feature, false);
}
